import { Flex, Input, useMediaQuery } from "@chakra-ui/react";
import { PrimayButton } from "components/customs/buttons";
import { useSocketContext } from "contexts/SocketContext";
import { SOCKET_EVENTS } from "lib/constants";
import { toast } from "react-toastify";
import { useState, useRef, useEffect } from "react";
// import { BACKEND_BASE_URL } from "lib/constants";

export function ChatForm({
  currentAdmin,
  senderId,
  receiverId,
  updateMessages,
}) {
  const { socket, isConnected } = useSocketContext();
  const [isMobile] = useMediaQuery("(max-width: 425px)");
  const [inputMsg, setInputMsg] = useState("");
  const focusRef = useRef(null);
  
  // ✅ Monitor connection status
  useEffect(() => {
    console.log('💬 ChatForm - Socket status:', {
      connected: isConnected,
      socketId: socket?.id,
    });
  }, [isConnected, socket?.id]);
  const handleChange = (event) => {
    setInputMsg(event.target.value);
  };
  // console.log("Plan For Today:=>>>", socket);
  // const handleResponse = ({ response, message }) => {
  //   updateMessages({ message });
  //   // console.log("root level response=>", response);

  //   if (response === "Message sent successfully") {
  //     console.log("handleResponse=>>", { response, message });
  //     updateMessages({ message });
  //   } else {
  //     // console.log("response=>", response);
  //     toast.error("Message sending failed");
  //   }
  // };

  useEffect(() => {
    if (focusRef.current && !!receiverId) {
      focusRef.current?.focus();
    }
  }, [receiverId]);

  const sendMessage = ({ message }) => {
    // ✅ Check connection before sending
    if (!socket?.connected) {
      console.error('❌ Socket not connected');
      toast.error('Connection lost. Please refresh the page.');
      return;
    }

    console.log('📤 Sending message:', {
      socketId: socket.id,
      event: SOCKET_EVENTS.SEND_MESSAGE,
      receiverId,
      message: message.substring(0, 50), // Log first 50 chars
    });

    // ✅ Send message via socket
    socket.emit(
      SOCKET_EVENTS.SEND_MESSAGE,
      { 
        receiverId,
        message,
      },
      ({ response }) => console.log("response", response)
    );

    // ✅ Optimistically update UI (shows message immediately for sender)
    updateMessages({
      message: {
        message,
        receiverId,
        senderId,
        senderRole: 'admin',
        receiverRole: 'user',
        senderName: currentAdmin?.username ?? "Admin",
        senderProfile: `${currentAdmin.profile_picture}`,
        createdAt: new Date().toISOString(),
      },
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const message = inputMsg.trim();
    if (!message || !receiverId) return;
    sendMessage({ message });
    setInputMsg("");
    // const formdata = new FormData(e.currentTarget);
    // const message = formdata.get("message");
    // e.currentTarget.reset();
  };

  return (
    <form
      onSubmit={handleSubmit}
      style={{
        position: "absolute",
        bottom: 0,
        background: "white",
        width: isMobile ? "auto" : "100%",
      }}
    >
      <Flex gap={2} p={{ sm: "0px 10px 25px 0px", md: "25px 10px" }}>
        <Input
          ref={focusRef}
          borderRadius="3xl"
          name="message"
          borderColor="#172C87"
          border="2px solid"
          value={inputMsg}
          placeholder="Type here..."
          onChange={handleChange}
          _placeholder={{ color: "#172C87",fontWeight: "800" }}
          // _focus={{
          //   borderColor: "#172C87",
          //   boxShadow: "0 0 0 1px #172C87",
          // }}
        />
        <PrimayButton
          label="Send"
          disabled={!inputMsg || inputMsg?.trim().length < 1 || !receiverId}
          sx={{
            color: "#5CBD5C",
            fontSize: "18px",
            background:"#F7FEF4",
            border: "2px solid #139913 !important",  // ✅ Correct
            outline: "none !important",
            width:'140px'
          }}
        />
      </Flex>
    </form>
  );
}
